export const testimonials = [
  {
    name: "周叙",
    role: "连续追更读者 · 两年",
    initials: "周",
    quote:
      "最大的感受是不用再自己拼时间线了。以前一个瓜要吃三天，现在打开一条记录，前因后果、谁先说了什么，一屏看完。",
  },
  {
    name: "林知夏",
    role: "内容运营从业者",
    initials: "林",
    quote:
      "它把「待核实」和「已核实」分得很清楚，这点在同类站点里很少见。做选题参考的时候，这层区分帮我省了很多判断成本。",
  },
  {
    name: "陈默",
    role: "前影视宣发",
    initials: "陈",
    quote:
      "有些事行业内早有风声，但外人只能看到碎片。黑瓜爆料的处理方式是留出回应位、标注信源状态，克制得让人愿意相信。",
  },
  {
    name: "许澄",
    role: "高校传媒专业学生",
    initials: "许",
    quote:
      "我把它的反转现场分类当成案例分析来看，一条时间线能清楚看到判断是在哪一步被推翻的，比教科书直观。",
  },
];